<template>

<div class="controls">

	<div>
		<i class="fal fa-circle-notch fa-spin fa-fw" v-if="loading"></i>
	</div>

	<div>
		<div class="switch round tiny" @click.prevent="toggle">
			<input type="checkbox" name="absorb-payments" v-model="absorbChargesStatus" >
			<label for="absorb-payments" class="right inline"></label>
		</div>
	</div>




	<!-- The Modal -->
	<div id="myModal" class="vue-modal" v-if="show">

	  <!-- Modal content -->
	  <div class="vue-modal-content">
	    <span class="close" @click="show = false">&times;</span>
	    <h4>Switching off Absorb Payments will also switch off Payment Secures Booking, are you sure you want to continue?</h4>


		<div class="row">
			<div class="columns small-6">
				<a href="#" class="button smaller" @click="show = false">No Thanks</a>
			</div>

			<div class="columns small-6">
				<a href="#" class="button success smaller" @click.prevent="setUpClubWithFeatures">Switch off Absorb Payments</a>
			</div>

		</div>

	  </div>

	</div>





</div>



</template>


<script>
'use strict';
	export default {
		name: 'ToggleWithLabel',
		data() {
			return {
				paymentSecuresBookingStatus: '',
				absorbChargesStatus: '',
				loading: true,
				show: false
			}
		},



		methods: {

			async getPaymentSecuresBookingStatus() {
				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_get_payment_secures_booking_settings');
					const request = new Request(url, {
						method: 'GET',
						credentials: 'same-origin'
					});

					const setting = await fetch(request);
					const settingJson = await setting.json();
					this.paymentSecuresBookingStatus = !!parseInt(settingJson.paymentSecuresBooking);
					this.absorbChargesStatus = !!parseInt(settingJson.absorbCharges);
					this.loading = false;
				} catch(error) {
					console.error(error);
				}

			},

			async toggle() {

				if(this.paymentSecuresBookingStatus) {
					this.show = true;
					return false;
				} else {
					this.turnOnAbsorbsCharges()
				}


			},

			async togglePaymentSecuresBooking() {
				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_toggle_feature', {feature: 'beta-payment-secures-booking'});
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});

					const statusRequest = await fetch(request);
					const statusJson = await statusRequest.json();
					this.loading = false;
					this.paymentSecuresBookingStatus = !!parseInt(statusJson.data);
				} catch(error) {
					console.error(error);
				}
			},

			async turnOnAbsorbsCharges() {
				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_update_platform_fees');
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});

					const statusRequest = await fetch(request);
					const statusJson = await statusRequest.json();
					this.loading = false;
					this.absorbChargesStatus = !!parseInt(statusJson.data);
					this.$emit('update-absorb', parseInt(statusJson.data));
				} catch(error) {
					console.error(error);
				}
			},

			setUpClubWithFeatures() {
				this.loading = true;
			 	this.turnOnAbsorbsCharges();
			 	this.togglePaymentSecuresBooking();
				this.show = false;
			},

			parseStatus(response) {
				if(response == 0) {
					this.status = false;
				} else if(response == 1) {
					this.status = true;
				} else {
					this.status = response;
				}
			},

		},

		computed: {
			booleanStatus() {
				if(this.status == 1) {
					return true;
				} else {
					return false;
				}
			},

			dynamicLabel() {
				if(this.status) {
					return `You have ${this.label} switched on!`;
				} else {
					return this.label;
				}
			},
			disableSwitch() {
				return this.disableIfToggledOn && this.status;
			}

		},

		components: {

		},

		beforeMount() {
		},

		mounted() {

		},
		created() {
			this.getPaymentSecuresBookingStatus();
		}

	};
</script>


<style scoped lang="scss">

[v-cloak] {
	display: none;
}

h6 {
	font-size: 0.7rem;
	color: #737373;
}

.grid-row {
	display: grid;
	grid-template-columns: 8fr 4fr;
	align-items: center;
}

.controls {
	display: grid;
	grid-template-columns: 1fr 1fr;
}

/* The Modal (background) */
.vue-modal {
  /*display: none;  Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.vue-modal-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */

  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;

  h4 {
	text-align: left;
	padding: 16px;
  }
}


@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

</style>
